import Components from "../components";

class AccountUserModal extends Components.Base {
  bind() {
    this.on("show.bs.modal", this.showModal.bind(this));
    this.on("hidden.bs.modal", this.hideModal.bind(this));
    this.on("change", "input:radio", () => this.activateButton());
    this.on("ajax:complete", () => {
      this.$el.modal("hide");
    });
  }

  showModal(event) {
    // dom_id follows the primary key while URLs follow to_param, so the two
    // diverge and no single attribute can serve both. data-id targets the
    // container; data-param builds the URL.
    this.dbId = event.relatedTarget.dataset.id;
    this.param = event.relatedTarget.dataset.param || this.dbId;
    this.$form = this.$el.find("form");
    this.$form.prop(
      "action",
      this.$form.prop("action").replace(/\/[^/]+$/, `/${this.param}`),
    );
    this.$form.data("container", `#account_user_${this.dbId}`);
    this.$el
      .find(".user-name")
      .text($(event.relatedTarget).parents("tr").find("td .name").text());
  }

  hideModal() {
    if (this.$el.find("input:radio").prop("checked", false).length > 0) {
      this.$el.find("button:submit").prop("disabled", true);
    }
  }

  activateButton() {
    this.$el.find("button:submit").prop("disabled", false);
  }
}

Components.collection.register({
  selector: ".c-user-role-modal, .c-user-destroy-modal",
  klass: AccountUserModal,
});
